import { encode } from 'blurhash';

export async function getSmallBlurhash(imageUrl: string, resolution: [number, number]) {
	const image = await loadWebImage(imageUrl);
	const imageData = getImageData(image);

	return encode(imageData.data, imageData.width, imageData.height, ...resolution);
}

async function loadWebImage(src: string) {
	return new Promise<HTMLImageElement>((resolve, reject) => {
		const img = new Image();
		img.onload = () => resolve(img);
		img.onerror = (...args) => reject(args);

		img.src = src;
	});
}

function getImageData(image: HTMLImageElement) {
	const canvas = document.createElement('canvas');
	canvas.width = image.width;
	canvas.height = image.height;
	const context = canvas.getContext('2d');
	if (!context) {
		throw Error('No canvas');
	}

	context.drawImage(image, 0, 0);

	return context.getImageData(0, 0, image.width, image.height);
}
